export enum FileUploadingStatus {
  uploading,
  uploaded,
  failed,
}
